import * as CookieConsent from 'vanilla-cookieconsent';

export function runCookieConsent(analyticsEnabledCallback) {
	CookieConsent.run({
		revision: 1,
		onConsent: function () {
			if (CookieConsent.acceptedCategory('analytics')) {
				analyticsEnabledCallback && analyticsEnabledCallback();
			}
		},
		guiOptions: {
			consentModal: {
				layout: 'bar',
				position: 'bottom',
				equalWeightButtons: false,
				flipButtons: false
			},
			preferencesModal: {
				layout: 'box',
				position: 'right',
				equalWeightButtons: true,
				flipButtons: true
			}
		},
		categories: {
			necessary: {
				readOnly: true
			},
			analytics: {}
		},
		language: {
			default: 'en',
			autoDetect: 'document',
			translations: {
				en: {
					consentModal: {
						title: 'Welcome!',
						description: "Our website uses cookies to ensure the best browsing experience. By selecting 'Accept All', you agree to our use of cookies. To customize your cookie preferences, click 'Manage Preferences'.",
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Manage preferences',
						footer: '<a href="https://www.campuscommunity.io/app-privacy-policy">Privacy Policy</a> <a href="https://www.campuscommunity.io/app-tos">Terms of Use for End-User</a>'
					},
					preferencesModal: {
						title: 'Consent Preferences Center',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Save preferences',
						closeIconLabel: 'Close modal',
						serviceCounterLabel: 'Service|Services',
						sections: [
							{
								title: 'Cookie Usage',
								description: "Our website uses cookies to ensure the best browsing experience. By selecting 'Accept All', you agree to our use of cookies."
							},
							{
								title: 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
								description:
									'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms.',
								linkedCategory: 'necessary'
							},
							{
								title: 'Analytics Cookies',
								description: 'Used to analyze website traffic and optimize your website experience. By accepting our use of analytics cookies, you help us improve our services.',
								linkedCategory: 'analytics'
							},
							{
								title: 'More information',
								description: 'For any query in relation to our policy on cookies and your choices, please <a class="cc__link" href="support@campuscommunity.io">contact us</a>.'
							}
						]
					}
				}
			}
		}
	});
}
